import React from "react"
import { Checkbox, Col, ControlLabel, FormControl, FormGroup } from "react-bootstrap"

export default function FormControlInlineCheckbox({ controlId, validationState, label, value,
  onChange, className, disabled }) {
  
    return (
      <FormGroup controlId={ controlId } validationState={ validationState }>
  
        <Col componentClass={ ControlLabel } sm={4}>
          { label }
        </Col>
  
        <Col sm={8}>
          <Checkbox checked={ value } onChange={ onChange } className={ className } disabled={ disabled }>
          </Checkbox>
          <FormControl.Feedback />
        </Col>
      </FormGroup>
    )
  }
  


// WEBPACK FOOTER //
// ./src/components/fragments/FormControl.Inline.Checkbox.js